// Shared by the purveyor profile editors (src/components/PurveyorProfileEditor.jsx)
// and the pages that host them. Kept out of the component file so React's
// fast refresh keeps working there.
import { COLORS, FONT_SIZE, SPACE, RADIUS } from "./constants";

export const emptyPurveyorProfile = () => ({
  name: "",
  description: "",
  isVerified: false,
  purveyorTypes: [],
  location: { address: "", city: "", state: "", zip: "" },
  contactInfo: { phone: "", email: "", website: "", socialUrl: "" },
});

export function editorStyles(colors) {
  const { ink, soft, accent, danger, line } = colors;
  return {
    input: { boxSizing: "border-box", width: "100%", padding: "var(--space-sm) var(--space-md)", borderRadius: RADIUS.md, border: `1px solid ${line}`, background: COLORS.card, color: ink, fontSize: FONT_SIZE.base, fontFamily: "var(--font-sans)" },
    label: { display: "flex", flexDirection: "column", gap: SPACE.xs, fontSize: FONT_SIZE.sm, color: soft },
    primary: { background: accent, color: COLORS.onAccent, padding: "var(--space-sm) var(--space-lg)", borderRadius: RADIUS.md, fontSize: FONT_SIZE.sm, fontWeight: 600 },
    secondary: { background: "transparent", border: `1px solid ${line}`, color: ink, padding: "var(--space-sm) var(--space-lg)", borderRadius: RADIUS.md, fontSize: FONT_SIZE.sm },
    danger: { background: "transparent", border: `1px solid ${line}`, color: danger, padding: "var(--space-sm) var(--space-lg)", borderRadius: RADIUS.md, fontSize: FONT_SIZE.sm },
    error: { color: danger, fontSize: FONT_SIZE.sm, margin: "var(--space-md) 0 0" },
    grid: (isMobile, cols) => ({ display: "grid", gridTemplateColumns: isMobile ? "1fr" : cols, gap: SPACE.lg }),
  };
}

// Boxes that are still open (not Delivered) and list this product.
export function openBoxesUsing(boxes, productId) {
  return boxes.filter((b) => b.status !== "Delivered" && b.items.some((it) => it.productId === productId));
}
